import { AccountCircle } from '@mui/icons-material'
import { CSSProperties, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import LanguageSwitcher from 'components/LanguageSwitcher'
import { securityApi } from 'hooks/api/security'
import { Security } from 'types/security'

export default function SettingPage(): JSX.Element {
  const { t } = useTranslation('page-setting')
  const [security, setSecurity] = useState<Security>()
  useEffect(() => {
    securityApi()
      .getMe()
      .then((res) => {
        setSecurity(res.data)
      })
  }, [])
  return (
    <div>
      <div style={languageSwitcherStyle}>
        <LanguageSwitcher />
      </div>
      <div style={profileStyle}>
        <AccountCircle sx={{ fontSize: '200px', color: 'silver' }} />
        <h2>
          {security?.lastName} {security?.firstName}
        </h2>
        <p style={securityIdStyle}>{t('security_id', { id: security?.id })}</p>
      </div>
    </div>
  )
}

// Styles
const languageSwitcherStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: '12px',
}

const profileStyle: CSSProperties = {
  textAlign: 'center',
  marginTop: '48px',
}

const securityIdStyle: CSSProperties = {
  marginTop: '10px',
}
